export default "__VITE_ASSET__CTE2DPW5__"